__turbopack_context__.v({
  "cards": "feature-cards-module-scss-module__zcF53q__cards",
});
